import {
  Box,
  Button,
  Group,
  Modal,
  Select,
  TextInput,
  Text,
} from '@mantine/core';
import React from 'react';
import TagList from './TagList';
import { theme } from '../consilitheme';

const SourceSelector = ({
  isEditMode,
  hasSource,
  selectedSource,
  sourcesData,
  handleSubmit,
  isModalOpen,
  interest,
  setIsModalOpen,
  customSource,
  setCustomSource,
  handleCustomSourceSubmit,
  setSources,
  removeTag,
}) => {
  return (
    <div>
      {' '}
      <Group align="flex-end">
        <Box sx={{ flexGrow: 1 }}>
          {' '}
          <Text size="md" fw={600}>
            Sources
          </Text>
          {!hasSource && isEditMode && (
            <Text
              size="sm"
              fw={500}
              mb={theme.padding.xs}
              c={theme.colors.red[3]}
            >
              Add a source to continue.
            </Text>
          )}
          {isEditMode ? (
            <Select
              mt={theme.padding.xs}
              disabled={!isEditMode}
              placeholder="Select source"
              value={selectedSource}
              data={sourcesData?.map((source) => source.name)}
              onChange={handleSubmit}
            />
          ) : (
            interest?.sources?.length == 0 && (
              <Text size="sm" c="gray">
                Click edit to add a source and get started.
              </Text>
            )
          )}
        </Box>{' '}
        <Modal
          opened={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Add Custom Source"
        >
          <TextInput
            value={customSource}
            onChange={(e) => setCustomSource(e.target.value)}
            placeholder="Enter custom source name"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleCustomSourceSubmit();
              }
            }}
          />
          <Button onClick={handleCustomSourceSubmit} mt="sm">
            Add Source
          </Button>
        </Modal>
      </Group>
      {interest?.sources?.length !== 0 && (
        <Box mb={theme.padding.md} mt={theme.padding.xs}>
          <TagList
            baseTags={interest.sources?.map((source) => source?.name)}
            activeTopics={interest.sources?.map((source) => source?.name)}
            setActiveTopics={isEditMode ? setSources : undefined}
            removableHint={isEditMode}
            defaultOutline
            large
            clickable={isEditMode}
            tagColor={theme.colors.blue[3]}
            tagType={'source'}
            removeTag={(tag, tagType) => removeTag(tag, tagType)}
          />
        </Box>
      )}
    </div>
  );
};

export default SourceSelector;
